import { Controller } from "@hotwired/stimulus"

// Cascading selectors for the task qualitative review: picking a charity care
// application narrows the user and task selectors to that application's charity
// care check-in tasks (and the users assigned to them).
export default class extends Controller {
  static targets = ["application", "user", "task"]
  static values = { options: Object }

  connect() {
    this.applicationChanged()
  }

  applicationChanged() {
    const options = this.optionsValue[this.applicationTarget.value] || {}
    this.populate(this.userTarget, options.users || [], "Select a user")
    this.populate(this.taskTarget, options.tasks || [], "Select a task")
  }

  populate(select, items, placeholder) {
    const previous = select.value
    select.innerHTML = ""
    select.add(new Option(items.length ? `-- ${placeholder} --` : "-- None available --", ""))
    items.forEach((item) => select.add(new Option(item.label, item.value)))
    select.disabled = items.length === 0
    if (items.some((item) => String(item.value) === previous)) select.value = previous
  }
}
